import styled from '@emotion/styled'
import { memo } from 'react'
import { StyledContentRoot } from '.'
import { getThemeSpacing } from '../../../styles/appTheme'
import APP_BREAKPOINTS from '../../../styles/breakpoints'
import { InlinePulseLoading } from '../../InlineLoading'
import YouMayLike from '../../YouMayLike/embedded/EmbeddedRecommendations'

const StyledModelsYouMayLikeContainer = styled('div')({
    maxWidth: APP_BREAKPOINTS.md,
    margin: '0 auto',
    paddingLeft: getThemeSpacing(1),
    paddingRight: getThemeSpacing(1),
})

interface ModelYouMayLikeProps {
    height: number
    id: number
    inRoom?: boolean
}

const ModelsYouMayLike = (props: ModelYouMayLikeProps) => {
    const { height, id, inRoom } = props
    return (
        <StyledContentRoot style={{ height }}>
            {id ? (
                <StyledModelsYouMayLikeContainer
                    css={{ paddingBottom: getThemeSpacing(1) }}
                >
                    <YouMayLike id={id} inRoomOrProfile={inRoom} />
                </StyledModelsYouMayLikeContainer>
            ) : (
                <InlinePulseLoading />
            )}
        </StyledContentRoot>
    )
}

export default memo(ModelsYouMayLike)
